

export default function Section6() {
  return (

<section class="bg-[#F5F5F5] py-0">
  <div class="container-1280 container mx-auto px-4 md:px-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
    
   
    <div class="space-y-8">
      <div>
        <h2 class="text-3xl md:text-4xl font-bold mb-4 text-[#DA2128]">
          Full-Service Digital Marketing Agency You Can Trust
        </h2>
        <p class="text-[16px] font-open text-[#373737] mt-10 lg:mt-0 mb-5">
          We are a results-driven digital marketing services company with a deep understanding of
          both local and global markets. Our expert team makes and carries out strategies that get real
          results. We focus on ethics and performance-based practices. We design responsive marketing
          websites and manage powerful ad campaigns. We take care of every part of your digital
          presence. We offer internet marketing services that focus on transparency and performance.
          Our aim is to boost your ROI and help you succeed in the long run.
        </p>
      </div>
      
      <div>
        <h2 class="text-3xl md:text-4xl font-bold mb-4 text-[#DA2128]">
          Your Business Goals, Our Digital Strategy
        </h2>
        <p class="text-[16px] font-open text-[#373737] mt-10 lg:mt-0 mb-5">
          At Mean3, we believe in clear communication, consistent performance, and long-term
          partnerships. We take time to understand your business, competitors, and audience before
          planning any campaign. That’s how we ensure our web marketing services are not just
          effective, but also aligned with your unique needs. We are a trusted digital marketing company.
          Our main goal is to create strategies that help you grow steadily in a changing digital world.
        </p>
      </div>
    </div>


    <div class="flex justify-center">
      <img src="assets/m4-1.png" alt="Digital Marketing Image" class="w-full max-w-md md:max-w-full"/>
    </div>

  </div>
</section>

    
  );
}
